import { StrictMode, useState, createContext, useContext, useEffect } from 'react';
import Header from './header';
import Footer from './footer';
import ClippedDrawer from './side-menu';
import { Backdrop, Box, CircularProgress, CssBaseline } from '@mui/material';
import Notification from '../shared/notification';
import { useAppDispatch, useAppSelector } from '../stores/hooks';
import EnvironmentSettingDialog from '../modules/settings/childcomponents/environmentSettingDialog';
import { AuthenticatedTemplate, useIsAuthenticated, useMsal } from '@azure/msal-react';
import { openEnvSettingDialog } from '../stores/envsettingdialogslice';
import { useNavigate } from 'react-router-dom';
import { InteractionStatus } from '@azure/msal-browser';
import { loginRequest } from '../../authConfig';
import userService from '../data/api/user.service';


interface ReloadState {
  reloadCounter: number,
  setReloadCounter: (newValue: number) => void,
}
export const ReloadStateContext = createContext<ReloadState>({ reloadCounter: 0, setReloadCounter: (newValue: number) => { } });
export default function Main({ body }: { body: React.ReactNode }) {
  const { instance, inProgress } = useMsal();
  const [reloadCounter, setReloadCounter] = useState(0);
  const value = { reloadCounter, setReloadCounter };
  const navigate = useNavigate();
  const isLoadingState = useAppSelector((state) => state.commonReducer.IsLoading);
  const currentDb = useAppSelector((state) => state.settingsReducer.Database);
  const isAuthenticated = useIsAuthenticated();
  const [canLoadItems, setCanLoadItems] = useState(false);
  const dispatch = useAppDispatch();
  useEffect(() => {

    if (inProgress === InteractionStatus.None && !isAuthenticated) {
      instance.loginRedirect(loginRequest);
    }
    else {
      userService.isCubicUser().then((response) => {
        if (response && response.data) {
          dispatch(openEnvSettingDialog());
        }
        else {
          setCanLoadItems(true);
        }
      })

    }
    // if(isAuthenticated){

    // }
    // else{
    //  //setCanLoadItems(false);
    //  //navigate('/');
    // }
  }, [inProgress]);
  useEffect(() => {
    if (currentDb && isAuthenticated) {
      setCanLoadItems(true);
    }
  }, [currentDb])

  return (
    <ReloadStateContext.Provider value={value}>
      <Box sx={{ display: 'flex', flex: 1 }}>
        <CssBaseline />
        <AuthenticatedTemplate>
          <Header />
          <ClippedDrawer />
          <StrictMode>
            {canLoadItems ?
              <Box key={reloadCounter} component="main" sx={{ flexGrow: 1, mt: 7, ml: 8, height: 'calc(100vh - 106px)', overflowY: 'auto' }}>
                {body}

              </Box> : null}
            <EnvironmentSettingDialog />
          </StrictMode>
          <Notification />
          <Footer />
        </AuthenticatedTemplate>
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={isLoadingState}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </Box>
    </ReloadStateContext.Provider>
  );
}
